import React from "react"
import ReactDOM from "react-dom/client"
import App from "./app"
import '@fortawesome/fontawesome-pro/css/all.css'
import '@fortawesome/fontawesome-pro/css/sharp-solid.css'
import "../semantic-ui/semantic.less"
import "./resources/css/main.css"
import "./resources/css/main-headerbar.css"
import "./resources/less/main.less"
import "./resources/less/mobile.less"
import "./resources/less/print.less"
import "./resources/less/mozilla.less"

const root = ReactDOM.createRoot(document.getElementById('app'))

root.render(
    <App />
)